/*
  NOTE:
  - These values are directly connected to the values defined in js/packages/blox/src/styles/icons.scss;
  - There's a loose TODO to investigate ways dynamically generate this array based on the contents of $blox-icons (e.g. SCSS exports)
*/

const Icons = [
  'ai',
  'apps',
  'archive',
  'arrow-right',
  'attachment',
  'bell',
  'bookmark',
  'bookmark-filled',
  'building',
  'bullet-list',
  'calendar',
  'check',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-small-down',
  'chevron-small-left',
  'chevron-small-right',
  'chevron-small-up',
  'chevron-up',
  'circle',
  'clock',
  'clock-filled',
  'close',
  'content-duplicate',
  'copy',
  'dash',
  'delete',
  'document',
  'download',
  'drag',
  'edit',
  'equalizer',
  'error',
  'expand',
  'flag',
  'flag-filled',
  'globe',
  'heart',
  'help',
  'helpscout',
  'history',
  'home',
  'home-condition',
  'home-filled',
  'image',
  'indicator-up',
  'indicator-down',
  'indicator-neutral',
  'info',
  'link',
  'loading',
  'location',
  'magic',
  'mail',
  'mail-lock',
  'mail-stacked',
  'megaphone',
  'more',
  'move-to',
  'mute',
  'new-window',
  'no',
  'pause-circle',
  'person',
  'person-add',
  'person-settings',
  'phone',
  'phone-callback',
  'phone-missed',
  'phone-outgoing',
  'pin',
  'pin-filled',
  'play-arrow',
  'play-circle',
  'plus',
  'refresh',
  'replay',
  'resize',
  'road',
  'search',
  'send',
  'settings',
  'share',
  'sort-asc',
  'sort-desc',
  'sms',
  'star',
  'star-filled',
  'sticky-note',
  'stop-circle',
  'subject',
  'sync',
  'table',
  'task',
  'task-complete',
  'task-progress',
  'task-todo',
  'undo',
  'upload',
  'vertical-mixer',
  'visibility',
  'voicemail',
  'volume',
] as const;

export default Icons;

export type IconType = (typeof Icons)[number];

export const IconOptions = Icons.map((icon) => ({ label: icon, value: icon }));
